export default {
  'art.metaTitle': 'Guía para principiantes del USFans Spreadsheet: Cómo investigar y comprar mejor',
  'art.metaDescription':
    '¿Nuevo en USFans? Esta guía para principiantes explica el USFans Spreadsheet, cómo navegar categorías, leer fotos de QC, estimar el envío y usar cupones con seguridad.',

  'art.breadcrumbHome': 'Inicio',
  'art.breadcrumbGuides': 'Guías',
  'art.breadcrumbCurrent': 'Guía para principiantes',

  'art.title': 'Guía para principiantes del USFans Spreadsheet',
  'art.subtitle': 'Cómo investigar productos, leer fotos de QC y comprar con confianza',
  'art.writtenBy': 'Escrito por el equipo editorial de USFans',
  'art.reviewedBy': 'Revisado por el equipo editorial de USFans',
  'art.updated': 'Última actualización',

  'art.intro':
    'Empezar con USFans puede resultar abrumador. Hay enlaces de productos que abrir, fotos de QC que revisar, opciones de envío que entender y detalles del almacén que considerar. Esta guía para principiantes te acompaña por el USFans Spreadsheet paso a paso, para que puedas investigar productos, entender el control de calidad y tomar decisiones informadas antes de comprar.',

  'art.h1': '¿Qué es el USFans Spreadsheet?',
  'art.p1a':
    'El USFans Spreadsheet es un recurso organizado que reúne enlaces de productos, categorías e información de compra en un solo lugar con buscador. En lugar de desplazarte por publicaciones o mensajes dispersos, puedes navegar por categoría y encontrar artículos relevantes más rápido.',
  'art.p1b':
    'Es una herramienta de investigación, no una tienda oficial. Siempre abre los enlaces, revisa los detalles en el sitio principal y haz tus propias comprobaciones antes de completar una compra.',

  'art.h2': 'Cómo funciona el USFans Spreadsheet',
  'art.p2a': 'La idea es simple: navega por una categoría, abre un enlace de producto, compara opciones y decide.',
  'art.l21': 'Navega por categorías como Zapatos, Sudaderas, Camisetas, Chaquetas y más.',
  'art.l22': 'Abre un enlace de producto para ver todos los detalles en el sitio principal.',
  'art.l23': 'Compara artículos similares antes de decidir.',
  'art.l24': 'Usa las guías para entender el QC, el envío y los cupones.',

  'art.h3': 'Entender las categorías principales',
  'art.p3a':
    'El spreadsheet está organizado en categorías claras para que encuentres lo que necesitas más rápido: Zapatos, Sudaderas/Suéteres, Camisetas, Chaquetas, Pantalones/Pantalones cortos, Gorras, Conjuntos, Ropa interior, Camisetas deportivas, Accesorios, Bolsos, Cinturones, Perfumes y Otras cosas.',
  'art.p3b':
    'Empieza por la categoría que coincide con lo que buscas y explora algunos artículos antes de reducir tu elección.',

  'art.h4': 'Cómo leer las fotos de QC',
  'art.p4a':
    'Las fotos de QC (control de calidad) son imágenes del artículo real antes de enviarse. Te ayudan a ver qué recibirás realmente.',
  'art.l41': 'Revisa de cerca las costuras y la ubicación del logo.',
  'art.l42': 'Compara colores y detalles con la ficha del producto.',
  'art.l43': 'Mira las medidas si están disponibles.',
  'art.l44': 'Pide más fotos si algo no está claro.',

  'art.h5': 'Costos de envío y qué los afecta',
  'art.p5a':
    'El envío puede cambiar el costo final de un pedido. Depende del destino, el peso del paquete, el volumen, la línea de envío, el empaque, el seguro e incluso la temporada.',
  'art.p5b':
    'Los precios varían, así que consulta siempre las tarifas actuales y estima antes de pagar en lugar de asumir una cifra fija.',

  'art.h6': 'Cupones y códigos de descuento',
  'art.p6a':
    'Los cupones y códigos de descuento pueden ayudarte a ahorrar, pero los códigos cambian con frecuencia. Revisa siempre el estado actual, el vencimiento y las restricciones antes de aplicar uno. Si no hay un código activo verificado, toma el precio regular como referencia.',

  'art.h7': '¿Es seguro USFans? Qué revisar',
  'art.l71': 'Verifica los enlaces antes de abrirlos.',
  'art.l72': 'Revisa con cuidado la información del vendedor.',
  'art.l73': 'Protege tu cuenta y tus datos de pago.',
  'art.l74': 'Revisa las condiciones de envío y devolución.',
  'art.l75': 'Ten cuidado con ofertas sospechosas o demasiado buenas.',

  'art.h8': 'Lista de verificación para principiantes',
  'art.l81': 'Decide qué categoría quieres navegar.',
  'art.l82': 'Abre y revisa varios enlaces de productos.',
  'art.l83': 'Revisa las fotos de QC y las medidas.',
  'art.l84': 'Estima el envío antes de pagar.',
  'art.l85': 'Busca algún cupón o descuento actual.',
  'art.l86': 'Confirma los datos del vendedor y del pago.',
  'art.l87': 'Revisa las políticas de devolución y reembolso.',
  'art.l88': 'Guarda registros de tu pedido.',

  'art.faqQ1': '¿Necesito una cuenta para navegar por el USFans Spreadsheet?',
  'art.faqA1':
    'Navegar por categorías y enlaces no requiere una cuenta. Las compras y funciones relacionadas con la cuenta se gestionan en el sitio principal.',
  'art.faqQ2': '¿Es gratuito el USFans Spreadsheet?',
  'art.faqA2':
    'El spreadsheet en sí es un recurso informativo gratuito. Cada producto tiene su propio precio, que debes verificar en el sitio principal.',
  'art.faqQ3': '¿Con qué frecuencia se actualiza el spreadsheet?',
  'art.faqA3':
    'Las actualizaciones pueden variar. Revisa siempre el sitio principal para ver los listados, precios y disponibilidad más recientes.',
  'art.faqQ4': '¿Puedo usar el spreadsheet en el móvil?',
  'art.faqA4': 'Sí, las categorías y enlaces son accesibles desde cualquier dispositivo con navegador.',

  'art.conclusion':
    'El USFans Spreadsheet es un punto de partida útil para investigar productos. Navega por las categorías, abre los enlaces, revisa las fotos de QC y estima el envío, y luego ve al sitio principal para completar tu compra. Para más información, vuelve a nuestra página de inicio para explorar guías, reseñas y recursos de envío.',
  'art.ctaHome': 'Volver a la página de inicio',
  'art.ctaSpreadsheet': 'Visitar sitio principal',
};